<template>
  <ValidationObserver ref="observer" tag="form">
    <div>
      <div>
        <b-form>
          <div id="tao-vai-tro" class="row">
            <b-form-group
              class="col-6 required"
              label="Tên vai trò"
              label-for="name"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Tên vai trò"
                rules="required|maxlength:50"
                v-slot="validationContext"
              >
                <b-form-group>
                  <b-form-input
                    id="name"
                    :state="getValidationState(validationContext)"
                    v-model="internalForm.name"
                    type="text"
                    required
                    :readonly="readonly"
                    placeholder=""
                  />
                  <b-form-invalid-feedback
                    >{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-form-group>
            <b-form-group
              label="Ứng dụng"
              label-for="app"
              class="required col-12"
              label-class="font-weight-bold"
            >
              <ValidationProvider
                name="Ứng dụng"
                rules="requiredMultiple"
                v-slot="validationContext"
              >
                <MultiSelect
                  :options="danhSachApp"
                  optionLabel="name"
                  optionValue="id"
                  class="w-100"
                  placeholder="Chọn ứng dụng"
                  :state="getValidationState(validationContext)"
                  :class="{
                    'select-invalid is-invalid':
                      validationContext.errors.length > 0,
                  }"
                  :disabled="readonly"
                  v-model="internalForm.applicationIds"
                  display="chip"
                ></MultiSelect>

                <b-form-invalid-feedback
                  :force-show="
                    validationContext.invalid && validationContext.validated
                  "
                  >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            <!-- T4+5 UC13.3: bắt buộc OTP khi đăng nhập theo vai trò. Bật OFF->ON hiện modal confirm số user
                 bị ảnh hưởng (xử lý ở CapNhatVaiTro trước khi submit). -->
            <b-form-group
              class="col-12"
              label-class="font-weight-bold"
            >
              <b-form-checkbox
                v-model="internalForm.requireOtpOnLogin"
                switch
                :disabled="readonly"
              >
                Bắt buộc OTP khi đăng nhập
              </b-form-checkbox>
            </b-form-group>
          </div>
        </b-form>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TaoVaiTro",
  data() {
    return {
      internalForm: {
        id: null,
        name: "",
        displayName: "",
        appId: null,
        applicationIds: [],
        thuTu: null,
        // T4+5 UC13.3: cờ bắt buộc OTP khi đăng nhập (bind từ detail - C1 KHÔNG default off âm thầm).
        requireOtpOnLogin: false,
      },
    };
  },
  computed: {
    ...mapGetters({ appId: "common/appId" }),
  },
  props: {
    form: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Object | null,
      required: false,
    },
    readonly: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Boolean | null,
      required: false,
    },
    danhSachApp: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Array | null,
      required: false,
    },
  },
  watch: {
    appId: {
      handler() {
        if (!this.readonly) {
          this.internalForm.appId = this.appId;
        }
      },
    },
    form: {
      handler() {
        if (this.$route.params.id === "tao-moi") {
          this.internalForm = {
            id: null,
            name: "",
            displayName: "",
            appId: null,
            applicationIds: [],
            thuTu: null,
            requireOtpOnLogin: false,
          };
          this.internalForm.appId = this.appId;
        } else {
          // C1: Object.assign kéo requireOtpOnLogin từ detail (form) -> UI hiện đúng trạng thái hiện tại.
          this.internalForm = Object.assign({}, this.internalForm, this.form);
        }
      },
      immediate: true,
    },
  },
  methods: {
    selectClass(valid) {
      return {
        "select-invalid": valid,
      };
    },
    lamMoi() {
      this.internalForm = {
        id: null,
        name: "",
        displayName: "",
        appId: null,
        applicationIds: [],
        thuTu: null,
        requireOtpOnLogin: false,
      };
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getInternalForm() {
      return {
        id: this.internalForm.id,
        name: this.internalForm.name,
        displayName: this.internalForm.displayName,
        appId: this.internalForm.appId,
        applicationIds: this.internalForm.applicationIds,
        thuTu: parseInt(this.internalForm.thuTu || 0),
        // T4+5 UC13.3: gửi cờ mandate (BE field bool? - luôn gửi bool để lưu trạng thái toggle hiện tại).
        requireOtpOnLogin: !!this.internalForm.requireOtpOnLogin,
      };
    },
    // T4+5 UC13.3: expose trạng thái cờ hiện trên form để CapNhatVaiTro detect OFF->ON (mở modal confirm).
    getRequireOtpOnLogin() {
      return !!this.internalForm.requireOtpOnLogin;
    },
  },
};
</script>

<style lang="scss">
.vs--searchable .vs__dropdown-toggle {
  border: 1px solid #ced4da;
  font-size: 1rem;
  height: 36px;
}
.vs--disabled {
  background: #e9ecef;
  .vs__dropdown-toggle,
  button:disabled,
  input:disabled,
  svg {
    background: #e9ecef !important;
  }
}
</style>
